export default __webpack_public_path__ + "static/media/constituency.19598256.webp";